// extracted by mini-css-extract-plugin
module.exports = {"cardFooter":"Card_cardFooter__3M0c9","cardBody":"Card_cardBody__1kYs6","extended":"Card_extended__1-Ef0"};